<template>
  <v-container>
    <v-row no-gutters class="mb-2">
      <v-btn v-if="getIsAdmin" text color="success" @click="createSupplier">
        <v-icon small left>fa-plus</v-icon>
        Nouveau Fournisseur
      </v-btn>
    </v-row>
    <v-card>
      <v-card-text>
        <SuppliersGrid></SuppliersGrid>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { SuppliersGrid } from "../components";
import { mapGetters } from "vuex";
export default {
  name: "SuppliersIndex",
  components: {
    SuppliersGrid
  },
  computed: {
    ...mapGetters(["getIsAdmin"])
  },
  data() {
    return {
      tab: 0
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.getData();
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.getData();
    next();
  },
  methods: {
    async getData() {
      this.$store.dispatch("loadSuppliers");
      this.$store.dispatch("loadTagCategories");
    },
    createSupplier() {
      this.$router.push({ name: "SuppliersEditor" });
    }
  }
};
</script>

<style lang="scss" scoped></style>
